var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 26.999
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "delete (1)",
  fill: "#26890d"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6146",
  d: "M14.062 9.779a.632.632 0 0 0-.632.632v11.95a.632.632 0 1 0 1.265 0v-11.95a.632.632 0 0 0-.633-.632Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6147",
  d: "M6.936 9.779a.632.632 0 0 0-.632.632v11.95a.632.632 0 1 0 1.265 0v-11.95a.632.632 0 0 0-.633-.632Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6148",
  d: "M1.72 8.038v15.578a3.575 3.575 0 0 0 .883 2.406 2.924 2.924 0 0 0 2.168.98h11.457a2.923 2.923 0 0 0 2.164-.977 3.575 3.575 0 0 0 .888-2.406V8.038a2.415 2.415 0 0 0 1.7-2.647 2.35 2.35 0 0 0-2.294-2.1h-3.1v-.789a2.541 2.541 0 0 0-.7-1.772 2.328 2.328 0 0 0-1.698-.728H7.811a2.328 2.328 0 0 0-1.7.725 2.541 2.541 0 0 0-.698 1.775v.79h-3.1a2.35 2.35 0 0 0-2.294 2.1 2.415 2.415 0 0 0 1.7 2.647Zm14.509 17.7H4.771A1.97 1.97 0 0 1 2.93 23.62V8.094h15.139v15.522a1.97 1.97 0 0 1-1.841 2.118ZM6.624 2.502a1.245 1.245 0 0 1 .344-.879 1.141 1.141 0 0 1 .843-.354h5.377a1.141 1.141 0 0 1 .843.354 1.245 1.245 0 0 1 .344.879v.79H6.624ZM2.313 4.553h16.373a1.139 1.139 0 0 1 0 2.276H2.313a1.139 1.139 0 0 1 0-2.276Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6149",
  d: "M10.499 9.779a.632.632 0 0 0-.632.632v11.95a.632.632 0 1 0 1.265 0v-11.95a.632.632 0 0 0-.633-.632Zm0 0"
}))));
export default SvgDelete;